const urls = {
  /* base: "/" */
  /* base: "/manual-test/" */
  base: "/adaptation-plat-draft-generator/"
};

export function manualUrl() {
  return urls.base;
}

export function manualPptxUrl() {
  return urls.base + 'pptx';
}

export default urls;
